import { CartItem } from "@/hooks/useCart";
import { PreviouslyPurchasedProduct } from "@/types/api/products";

export function findRecommendationsBasedOnOrderHistory(
  orderHistory: PreviouslyPurchasedProduct[] = [],
  cartProducts: CartItem[] = []
): PreviouslyPurchasedProduct[] {
  return orderHistory.filter(
    ({ product: { id: product_id } }) =>
      !cartProducts?.find((cartItem) => cartItem.id === product_id)
  );
}
